
  import { hydrateRoot } from "react-dom/client";
  import { StrictMode } from "react";
  import Component from "src/routes/app/home.page.tsx";

  hydrateRoot(
    document,
    <StrictMode>
      <Component {...window.clientProps} />
    </StrictMode>,
  );
  